import React, { useRef, useEffect } from 'react';

export const usePrevious = <T>(value) => {
  const ref: React.MutableRefObject<T | undefined> = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
